import Api from './../api'

export default DataLayer => DataLayer.$extend('elastic', {
    search(keywords, limit = 30, offset = 0) {
        return Api.elastic.search({ query: keywords, limit, offset })
    },
})
